import { TransactionSuccessToast } from "@/components";
import type { TransactionHash } from "@/types";
import { ToastSimpleRow } from "./ToastSimpleRow";

export interface VoteSuccessToastProps {
    transactionHash: TransactionHash;
    onClose?: () => void;
}

export function VoteSuccessToast({ transactionHash, onClose }: VoteSuccessToastProps) {
    return (
        <TransactionSuccessToast title="Thank you for voting!" transactionHash={transactionHash} onClose={onClose}>
            <ToastSimpleRow label="Voted" />
        </TransactionSuccessToast>
    );
}
